import { Fragment } from 'react';
import * as Styles from './flow-card-styles.module.less';
import { observer } from 'mobx-react';
import { Form, Text, Togglebox, Stack, Divider } from '@servicetitan/design-system';
import { FieldState, FormState } from 'formstate';
import classNames from 'classnames';
import { FlowCard, FlowCardProps } from './flow-card';

import { FlowCardRadioCompleted } from './flow-card-radio-completed';

export type FlowCardRadioForm = FormState<{
    answer: FieldState<number | undefined>;
    formId: FieldState<string>;
}>;

interface FlowCardRadioProps extends FlowCardProps {
    cardId: number;
    form: FlowCardRadioForm;
    options: FlowCardRadioOptions[];
    header: string;
    additionalNotes?: string;
    primaryButtonName: string;
    onPrimaryButtonClick(): void;
}

export interface FlowCardRadioOptions {
    id?: number;
    label: string;
    divider?: boolean;
}

export const FlowCardRadio = observer((props: FlowCardRadioProps) => {
    const { isComplete, additionalNotes, form, options, header } = props;
    const toggleBoxes = options.map(option => {
        const { answer, formId } = form.$;
        const isChecked =
            (option.id !== undefined || form.$.answer.dirty || isComplete) &&
            answer.value === option.id;
        return (
            <Fragment key={`${option.label}-${option.id}`}>
                {option.divider && <Divider spacing={2} className="m-b-0-i" />}
                <Togglebox
                    control="radio"
                    value={option.id}
                    onClick={answer.onChange}
                    name={formId.value}
                    label={option.label}
                    controlAlign="top"
                    className={classNames('fs-4-i', 'w-50-i', Styles.toggleBox)}
                    checked={isChecked}
                />
            </Fragment>
        );
    });
    return (
        <FlowCard
            disablePrimaryButton={isComplete ? false : !form.$.answer.dirty}
            completedInfo={<FlowCardRadioCompleted form={form} options={options} title={header} />}
            {...props}
        >
            {!!additionalNotes && (
                <Text subdued size={2} className="w-50 m-t-0 p-b-1">
                    {additionalNotes}
                </Text>
            )}
            <div className="m-t-2">
                <Form>
                    <Stack spacing={2} direction="column" className="m-b-1-i">
                        {toggleBoxes}
                    </Stack>
                </Form>
            </div>
        </FlowCard>
    );
});
